<template>
   <div class="product-list">
    
    

    
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="近7天数据" name="type7"></el-tab-pane>
        <el-tab-pane label="近30天数据" name="type30"></el-tab-pane>
        <el-tab-pane label="全部" name="typeall"></el-tab-pane>
      </el-tabs>
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="选择日期">
          <el-date-picker
            v-model="searchForm.selectedDate"
            type="date"
            placeholder="选择日期"
            size="small"
          ></el-date-picker>
        </el-form-item>  

        <el-form-item label="商品关键词"><el-input size="small" v-model="searchForm.product_name" placeholder="关键词搜索"></el-input></el-form-item>
        <el-form-item>
            <div class="relative"  v-if="isuse == 1">
              <div class="border rounded px-3 py-2 cursor-pointer" @click="toggleSupplierDropdown">
              {{selectedSupplier ? selectedSupplier.name : '选择批发点'}}
              <i class="fas fa-chevron-down absolute right-2 top-3"></i>
              </div>
              <div v-if="showSupplierDropdown" class="absolute z-10 w-full bg-white border rounded mt-1 shadow-lg">
              <div v-for="item in supply" :key="item.supply_id" 
              class="px-3 py-2 hover:bg-gray-100 cursor-pointer"
              @click="selectSupplier(item)">
              {{item.name}}
              </div>
              </div>
        </div>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>

          <el-form-item><el-button size="small" type="success" @click="onExport"  
            >导出全部</el-button></el-form-item>
        </el-form-item>
      </el-form>
    </div>


    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading"   >
          <el-table-column prop="product_name" label="产品" width="300px">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.image?scope.row.image.file_path:error_img" alt="" /></div>
                <div class="info">
                  <div class="name">{{ scope.row.product_name }}</div>
                  <div class="price">￥{{ scope.row.product_price }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="supply_id" label="所属供应商" width="300px">
            <template slot-scope="scope">
               <div class="name" v-if="scope.row.supply_id>0">
                  <p>商家名称：{{scope.row.supply.name}}</p>
                  <p>商家ID：{{scope.row.supply_id}}</p>
                </div>
                <div v-else>平台</div>
            </template>
          </el-table-column>

          <el-table-column prop="sales_volume" label="销售额"></el-table-column>
          <el-table-column prop="total_sales_num" label="销量"></el-table-column>
          
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>

  </div>
</template>

<script>
  import qs from 'qs'
  import StatisticsApi from '@/api/statistics.js';
  import Warehouse_managementApi from '@/api/warehouse_management.js';
  export default{
    components:{
    },
    data(){
      return{
        /*是否正在加载*/
        activeName: 'type7',
        loading: true,
        tableData:[],
        /*一页多少条*/
        pageSize: 10,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索参数*/
        searchForm: {
          product_name: '',
          supply_key: '',
          selectedDate:"",
          supply_id:"",
        },
        /*数据对象*/
        dataModel:{},
        supply:[],
        form:{

        },
        isuse:0,
        selectedSupplier: null,
        showSupplierDropdown:false,
        
      }
    },
    provide: function () {
      return {
        dataModel: this.dataModel
      }
    },
    created() {
      /*获取数据*/
      var self = this;
      self.getInas({},function(res){
        self.isuse = res
      })
      self.getSupplys()
      self.getData();
    },
    methods:{
      selectSupplier(item) {
        this.selectedSupplier = item;
        this.searchForm.supply_id = item.supply_id
        this.showSupplierDropdown = false;
   
      },
      toggleSupplierDropdown() {
        this.showSupplierDropdown = !this.showSupplierDropdown;
  
        this.showWarehouseDropdown = false;
  
      },
      getSupplys(){
            let self = this;
            Warehouse_managementApi.getSupply({}, true)
                .then(data => {
              
                self.supply = data.data.supply
                self.form_w.supply_id = self.supplyArr[0].supply_id
                self.form_w.t_supply_id = self.supplyArr[0].supply_id
                self.form_w.product_sku_id = self.productArr[0].product_sku_id

                self.form_o.supply_id = self.supplyArr[0].supply_id
                self.form_o.t_supply_id = self.supplyArr[0].supply_id
                self.form_o.product_sku_id = self.productArr[0].product_sku_id
                })
                .catch(error => {
                });
        },
 
      onExport: function() {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/order.operate/exportp?' + qs.stringify(this.searchForm);
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.loading = true;
        self.curPage = val;
        self.getData();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.pageSize = val;
        this.getData();
      },

      /*切换菜单*/
      handleClick(tab, event) {
        let self = this;
        self.curPage = 1;
        self.getData();
      },
      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getData();
      },

      /*获取数据*/
      getData() {
        let self = this;
        let Params = self.searchForm;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.type = self.activeName;
        self.loading = true;

        StatisticsApi.getProductSales(Params, true)
          .then(res => {
            self.tableData = res.data.list.data;
            self.totalDataNumber = res.data.list.total;
            self.loading = false;
          })
          .catch(error => {});
      }

    }
  }
</script>

<style>

.btn-primary {
    @apply bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50;
  }
  .btn-default {
    @apply bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50;
  }
  
  .max-h-40::-webkit-scrollbar {
    width: 6px;
  }
  
  .max-h-40::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  
  .max-h-40::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }
  
  .max-h-40::-webkit-scrollbar-thumb:hover {
    background: #666;
  }
</style>



// WEBPACK FOOTER //
// src/views/statistics/productsales/index.vue